var map = {
	"./sub-logo-chs.png": 37110,
	"./sub-logo-cht.png": 80641,
	"./sub-logo-en.png": 15380,
	"./sub-logo-jp.png": 44688,
	"./sub-logo-kr.png": 47394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58812;